export default "__VITE_ASSET__fa08d324__"